  $(function() {

    $('.js-dropdown-trigger').focus( function () {
      $(this).siblings('.js-dropdown-menu').addClass('focused');
    }).blur(function(){
      $(this).siblings('.js-dropdown-menu').removeClass('focused');
    });
  
  // // For children
    $('.js-dropdown-menu button, .js-dropdown-menu a').focus( function () {
      $(this).parents('.js-dropdown-menu').addClass('focused');
    }).blur(function(){
      $(this).parents('.js-dropdown-menu').removeClass('focused');
    });
  });